<template>
  <div>
    <DynamicToggleCollapse :titles="[{id:'Geofence-filter',name:'Geofence filter'},{id:'Device-filter',name:'Device filter'}]">
  <b-collapse id="Device-filter">
         <b-card>
          <DevicesListFilters
 @divicesFilterd="divicesFilterd"
 @merageFilterWithRequest="merageFilterWithRequest"
 :haseSupportFilter="true"
 
 /> 
         </b-card>
        </b-collapse>

      <b-collapse id="Geofence-filter">
         <b-card>
          <GeofencesListFilters 
  @geofencesFilterd="geofencesFilterd" 
  @merageGeofencesFilterWithRequest="merageGeofencesFilterWithRequest"
  />
         </b-card>
        </b-collapse>
</DynamicToggleCollapse>
    <!-- form report -->
    <b-card style="position: relative">
      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>

    <b-form @submit.prevent="getReport" class="">


     


   

        <b-row class="mt-2">
     <b-col cols="4">
            <b-form-group :label="$t('geofences')" label-for="vi-containers-id">
              <v-select multiple :close-on-select="false" v-model="request.geofences" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="[{ name: $t('all'), id: 'all' }, ...geofences]"
                :reduce="d => d.id" v-on:input="reFilterDevices('geofences',request)" />
              <small v-if="errors && ('geofences' in errors)" class="text-danger">
                {{ $t(errors['geofences'][0]) }}
              </small>
            </b-form-group>
          </b-col>
 <b-col cols="4">
            <b-form-group :label="$t('Devices')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.devices" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="[{ name: $t('all'), id: 'all' }, ...devices]"
                :reduce="d => d.id" />
              <small v-if="errors && ('devices' in errors)" class="text-danger">
                {{ $t(errors['devices'][0]) }}
              </small>
            </b-form-group>
          </b-col>
     <b-col cols="4">
      <br/>

            <b-form-group>
              <b-form-radio-group id="btn-radios-1" v-model="request.groupBy"
                :options="[{text: $t('Group By day'), value: 'day' },{text: $t('Group By device'), value: 'device' }]"
                name="radios-btn-default" />
                 <small v-if="errors && ('groupBy' in errors)" class="text-danger">
                {{ $t(errors['groupBy'][0]) }}
              </small>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="6">
            <!-- report range date -->
            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
              <flat-pickr v-model="rangeDate" :state="null" class="form-control" :config="pickerOptions"
                placeholder="YYYY-MM-DD" />

              <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
                :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
                {{('from' in errors) ? errors['from'][0] : '' }}
                {{('to' in errors) ? errors['to'][0] : '' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>


          <b-col cols="6">
            <b-form-group :label="$t('event type')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.types" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="[...event_types.map((t)=>({'id':t.id,'name':$t(t.name)}))]"
                :reduce="d => d.id" />
              <small v-if="errors && ('types' in errors)" class="text-danger">
                {{ $t(errors['types'][0]) }}
              </small>
            </b-form-group>
          </b-col>


        </b-row>
       
          
         

         

         
       
        <b-row class="mt-2">
          <!-- reset and submit -->
          <b-col cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>
        </b-row>
   
    </b-form>
  </b-card>
    <div v-if="report_data">
  <DataTable
     :report_data="report_data" 
     :report_fields="report_fields"
     :filter_included_fields="filter_included_fields"
     :request="request"
     :errors="errors"
     :loading="dataTableloading||loading"
     :getReport="getReport"
     :total="total"
     :from="from"
     :to="to"
     :sortData="sortData">
  </DataTable>

</div>
    
  </div>

</template>

<script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput,BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText,BLink,BMedia,BCollapse
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref ,computed, watch} from '@vue/composition-api'

import {
  createFrame, createjsPDFInstance, createTable
} from '@/share/reports/pdfCommonFunctions'

import Cleave from 'vue-cleave-component'
import reportForm from '@/app/reports/history/reportForm'
import ReportLogic from '@/app/reports/history/logic'
import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'
import DynamicToggleCollapse from '@/views/ui/toggle-collapse/DynamicToggleCollapse.vue'
import {ExportDataServices}  from  '@/share/reports/exportService'

import { useToast } from 'vue-toastification/composition'
import  DevicesListFilters from '../filters/DevicesListFilters.vue'
import FilterLogic   from  '@/views/reports/filters/filterLogic.js'

import GeofencesListFilters from '@/views/reports/filters/geofences/GeofencesListFilters.vue'
import GeofenceFilterLogic  from '@/views/reports/filters/geofences/filterLogic.js'
import DataTable from '@/views/reports/data-table/DataTable.vue'

import  ReportOptions from  '@/views/reports/components/options.js'

  
    
export default {
  name: 'HistoryReport',
  components: {
    BRow, BCard,BFormCheckboxGroup, BTable,BPagination,BCollapse,
    BCol,BFormRadioGroup, BFormInvalidFeedback,
    BAlert, BFormGroup, BFormInput,flatPickr,
    BFormCheckbox, BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    Cleave,
    BLink,
    BMedia,
    ToggleCollapse,
    DevicesListFilters,
    GeofencesListFilters,
    DynamicToggleCollapse,
    DataTable
  },
  directives: { Ripple, },

  setup(props, { root, emit }) {

  const event_types=ref([
   {id:'deviceMoving',name:'deviceMoving'},
   {id:'geofenceEnter',name:'geofenceEnter'},
   {id:'geofenceExit',name:'geofenceExit'},
   {id:'deviceStopped',name:'deviceStopped'},
   {id:'ignitionOn',name:'ignitionOn'},
   {id:'ignitionOff',name:'ignitionOff'},
   // {id:'alarm',name:'alarm'},
   {id:'maintenance',name:'maintenance'},
  ])

const geofencesFilterd=(data)=>{
  geofences.value=data;
}

 const divicesFilterd =(data)=>{      
       devices.value=data;
    }
    const merageFilterWithRequest = (data) => {
     
     delete data['type']
   if(data['isSupport']=="all"){
     delete data['isSupport']
     delete request.value.isSupport
   }

   Object.assign(request.value, data);
 }

    const merageGeofencesFilterWithRequest=(data)=>{
      delete data['type']   
     
      Object.assign(request.value, data);
    }
    
     
    const toaster = (msg, variant, title) => {
      root.$root.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
      })
    }
    const {geofences}=GeofenceFilterLogic()
    const {devices}  =FilterLogic()

    const tableRef = ref(null)

    const { owners,    contracts,types,reFilterDevices,filterdata,areas_contracts,areas_owners} = reportForm()
   

    const { report_data, request, errors, loading, getReport, getReportForPdf, total, from, to,isSortDirDesc,sortBy ,dataTableloading} = ReportLogic()
    const sortData=(data)=>{
      sortBy.value=data.sortBy
      isSortDirDesc.value=data.isSortDirDesc
    }

    const perPageOptions = [5, 10, 25, 50, 100]

    const rangeDate = ref('')
        
    const {pickerOptions} =ReportOptions(request.value)

    const report_wrapper = ref(null)

    const filter_included_fields=[ 'device','time','area', 'type','owner','contract' ]
    const report_fields=[
      {
        key: 'index',
        label: 'id',
       
      },
      {
        key: 'owner',
        label: 'owner',
        sortable: true
      },
      {
        key: 'contract',
        label: 'contract',
        sortable: true
      },
      {
        key: 'device',
        label: 'device',
        sortable: false
      },
      {
        key: 'time',
        label: 'time',
        sortable: false
      },
      {
        key: 'area',
        label: 'area',
        sortable: false
      },

      {
        key: 'type',
        label: 'type',
        sortable: false
      },

      {
        key: 'location',
        label: 'location',
        sortable: false
      },
      


    ]

    return {
      report_data,filter_included_fields,report_fields, total, from, to,rangeDate,
      tableRef,
      getReport,
      perPageOptions,

     
     getReportForPdf,
      pickerOptions,
      report_wrapper,
     

      request,
      loading,
      errors,
     devices,
     owners,
    contracts,
    geofences,
    types,
    reFilterDevices,
    filterdata,
    areas_owners,
    areas_contracts,
    divicesFilterd,
    merageFilterWithRequest,
    geofencesFilterd,
    merageGeofencesFilterWithRequest,
    event_types,
    sortData,
    dataTableloading
    }


  },

  

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}

</style>
